export default "__VITE_ASSET__2d7f6cb7__"